import { render, staticRenderFns } from "./ListItemForCandidates.vue?vue&type=template&id=0f6047d1"
import script from "./ListItemForCandidates.vue?vue&type=script&lang=js"
export * from "./ListItemForCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports